window.SLDS = window.SLDS || {};

window.SLDS.carouselHero = (speed = 80) => ({
  paused: false,
  duration: 0,
  speed: speed,

  init() {
    this.calculateDuration();
  },

  calculateDuration() {
    const track = this.$refs.marquee;

    if (track && track.offsetWidth > 0) {
      this.duration = track.offsetWidth / this.speed;
    }
  },
});
